import { styled } from "@mui/material";

export const Section = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    // padding: '24px  96px',
    [theme.breakpoints.down('md')]: {
        // padding: '24px  48px'
    },
    [theme.breakpoints.down('sm')]: {
        // padding: '12px  24px ',
    },
    [theme.breakpoints.down('xs')]: {
        // padding: '12px 0px',
    },

}))
export const Content = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down("sm")]: {
    }
}))
export const ContentBox = styled('section')(({ theme }) => (props) => ({
    padding: '24px 48px',
    width: '800px',
    backgroundColor: '#0056D21A',
    borderRadius: theme.shape.bigBorderRadios,
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px',
    },
}))
export const HeaderText = styled('h3')(({ theme }) => (props) => ({
    fontSize: "24px",
    fontWeight: "800",
    lineHeight: "29px",
    color: theme.palette.mode === "light" ?
        theme.palette.text.lightSecondary : theme.palette.text.darkSEcondary,
    margin: '0'
}))
export const TrophyRight = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    flexDirection: 'column',
    // width: '30%',
    // [theme.breakpoints.down('md')]: {
    //     width: '40%',
    // },
    // [theme.breakpoints.down('sm')]: {
    //     width: '60%',
    // },
    // [theme.breakpoints.down('xs')]: {
    //     width: '%',
    // }
}))
export const CompStud = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',

}))
export const StudImage = styled('div')(({ theme }) => (props) => ({
    width: '48px',
    height: '48px',

}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: '50%'
}))
export const Rate = styled('p')(({ theme }) => (props) => ({
    fontSize: '20px',
    fontWeight: '500',
    flex: 1,
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))
export const TrophyLeft = styled('div')(({ theme }) => (props) => ({
    width: '40%',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    }
}))